import { render, staticRenderFns } from "./SMSVerification.vue?vue&type=template&id=4bcd307f&scoped=true"
import script from "./SMSVerification.vue?vue&type=script&lang=js"
export * from "./SMSVerification.vue?vue&type=script&lang=js"
import style0 from "./SMSVerification.vue?vue&type=style&index=0&id=4bcd307f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd307f",
  null
  
)

export default component.exports